import { useEffect } from "react"
import { useGlobalState } from "../Components/GlobalStateProvider"

const LAST_SEEN_STORAGE_KEY = "user_last_seen_timestamp"
const THIRTY_MINUTES_MS = 30 * 60 * 1000
const CHECK_INTERVAL_MS = 60 * 1000 // Check every minute

export function useLastSeenUser() {
  const { currentUser } = useGlobalState()
  const skeem = window.skeem

  useEffect(() => {
    if (!currentUser.id) return

    async function updateLastSeen() {
      const now = Date.now()
      const lastUpdateStr = localStorage.getItem(LAST_SEEN_STORAGE_KEY)
      const lastUpdate = lastUpdateStr ? parseInt(lastUpdateStr, 10) : 0

      // Only update if 30 minutes have passed since last update
      if (now - lastUpdate >= THIRTY_MINUTES_MS) {
        console.log("Updating last seen for user", currentUser.id)
        
        try {
          await skeem.mutate({
            skeem_users: { update: { id: currentUser.id!, last_seen: new Date() } },
          })
          
          // Store the timestamp of successful update
          localStorage.setItem(LAST_SEEN_STORAGE_KEY, now.toString())
        } catch (error) {
          console.error("Failed to update last seen:", error)
        }
      }
    }

    // Update immediately on mount (if 30 mins have passed)
    updateLastSeen()

    // Set up interval to check periodically
    const intervalId = setInterval(updateLastSeen, CHECK_INTERVAL_MS)

    return () => clearInterval(intervalId)
  }, [currentUser.id, skeem])

  return null
}